import { ChakraImage as Image, ChakraBox as Box, ChakraText as Text } from "@airhelp/react-ui-components";
import { icons } from "./ListCard.config";
import type { ListCardProps } from "./ListCard.d";

export const ListCard = ({
  listItems,
  title,
  mtMobile = "6",
  mtTablet = "6",
  mtDesktop = "6",
  mbMobile = "6",
  mbTablet = "6",
  mbDesktop = "6",
}: ListCardProps) => (
  <Box
    width="full"
    px={{ base: 4, md: 0 }}
    py={6}
    mt={{ base: mtMobile, md: mtTablet, lg: mtDesktop }}
    mb={{ base: mbMobile, md: mbTablet, lg: mbDesktop }}
    boxShadow={{ base: "lg", md: "none" }}
    bg={{ base: "greyscale.100", md: "transparent" }}
    borderRadius="xl"
  >
    <Text
      fontSize="xs"
      color="primary.900"
      textTransform="uppercase"
      fontWeight="bold"
      letterSpacing="1.5px"
      p={0}
      mb={{ base: 7, xl: 4 }}
    >
      {title}
    </Text>

    <Box display="flex" flexDirection={{ base: "column", md: "row" }} gap={7} flexWrap="wrap">
      {listItems.map(({ _uid, text, icon }) => (
        <Box key={_uid} display="flex" alignItems="center">
          <Image src={icons[icon]} boxSize={12} mr={{ base: 2, xl: 3 }} />
          <Text fontSize="md">{text}</Text>
        </Box>
      ))}
    </Box>
  </Box>
);
